export const RoutePaths = {
  home: "/",
  aboutus: "/aboutus",
  services: "/services",
  careers: "/careers",
  contact: "/contact",
};
